module.exports = __webpack_public_path__ + "img/slide-2.81793610.png";